import { render, staticRenderFns } from "./EpisodeButton.vue?vue&type=template&id=13c56506&scoped=true&"
import script from "./EpisodeButton.vue?vue&type=script&lang=js&"
export * from "./EpisodeButton.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeButton.vue?vue&type=style&index=0&id=13c56506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c56506",
  null
  
)

export default component.exports